import type { NotificationChannel } from './types';

export const DEFAULT_LOCALE = 'en-US' as const;

export const EMAIL_CHANNEL = 'email' satisfies NotificationChannel;

export const SMS_CHANNEL = 'sms' satisfies NotificationChannel;
